/* eslint-disable camelcase */
import { MAX_ROIS_TO_DISPLAY } from "config/constants";
import { getCanvasAnnotationsFromROI } from "features/canvas/utils";
import { CanvasAnnotation, ROI } from "types/imageAnnotations";
import { ResultBlob } from "types/imageQueries";
import { LabelValue } from "types/labelValue";

// Colors Array for annotations
export const colors = ["#00C7D9", "#FEC519", "#FE66B2", "#CA00EB", "#6950E6"];

// This function compares the data array of roi with the bbox array that is attached to the predictor
// and then tries to get the index of the ocurrence
// Depending the found index if will get the corresponding color and added that color to the roi .

export function fromBackendROIs(
  resultBlob: ResultBlob | undefined | LabelValue | null,
): CanvasAnnotation[] | undefined {
  if (!resultBlob) return undefined;
  const { rois, source } = resultBlob;

  if (!rois) return undefined;

  let parseData: ROI[]= rois;

  if (source === "ALG") {
    // Sort the rois by score in descending order
    parseData?.sort((a: ROI, b: ROI) => b.init_args.score - a.init_args.score);
    // Slice the first 5 rois from the array to avoid the case where the user has a lot of rois made by the ML
    parseData = parseData?.slice(0, MAX_ROIS_TO_DISPLAY);
  }

  // Parse a list of ROIs coming from the backend into a list of ROIAnnotations. We then filter out
  // any ROIs that could not be parsed. If data is undefined, we return undefined.
  return parseData?.map((roi: ROI, index) => getCanvasAnnotationsFromROI(roi, index)).filter(Boolean);
}
